import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const search = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.query === undefined) {
        throw new Error('Missing required parameter: query');
    }
    const path = '/api/ws-search/search';
    const pathInternal = '/api/search';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.query !== undefined) {
        urlParams.append('query', params.query.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
search.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
